"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTrailingSlash = removeTrailingSlash;
exports.addLeadingSlash = addLeadingSlash;
exports.removeLeadingSlash = removeLeadingSlash;
exports.getRouteName = getRouteName;
exports.getRouteConfig = getRouteConfig;
exports.getUrl = getUrl;

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.string.ends-with");

var _urlParse = _interopRequireDefault(require("url-parse"));

var _runtime = _interopRequireDefault(require("./runtime"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSlash(p) {
  return p === "/";
}

function removeTrailingSlash(p) {
  return !isSlash(p) && p.endsWith('/') ? p.slice(0, -1) : p;
}

function addLeadingSlash(p) {
  return p.startsWith('/') ? p : "/".concat(p);
}

function removeLeadingSlash(p) {
  return !isSlash(p) && p.startsWith('/') ? p.slice(1) : p;
}

function getRouteName(passedPath) {
  // const routeNameMap = runtime.get('routeNameMap')
  var pathname = passedPath || window.location.pathname; // const p = removeTrailingSlash(pathname)
  // return routeNameMap[p] || pathname

  var config = getRouteConfig(pathname);
  return config ? config.name : pathname;
}

function getRouteConfig(passedPath) {
  var routeConfig = _runtime.default.get('routeConfig');

  var pathname = passedPath || window.location.pathname;
  var p = removeTrailingSlash(pathname);
  return routeConfig[p] || {};
}

function getUrl() {
  return "".concat(location.protocol, "//").concat(location.host).concat(location.pathname);
}